import React from 'react';
import { createSmallTableClassName } from './smallTableStyles';

export const SmallTableWrapperComponent: React.FC = (props) => {
  const { children } = props;

  const wrapperClassName = createSmallTableClassName('wrapper');

  return <div className={wrapperClassName}>{children}</div>;
};

export const SmallTableRowComponent: React.FC = (props) => {
  const { children } = props;

  const rowClassName = createSmallTableClassName('row');

  return <div className={rowClassName}>{children}</div>;
};

export const SmallTableExtraComponent: React.FC = (props) => {
  const { children } = props;

  const extraClassName = createSmallTableClassName('extra');

  return <div className={extraClassName}>{children}</div>;
};
